import React from "react";
import { string } from "prop-types";
import { Link } from "react-router-dom";
import * as style from "./styles.module.scss";

const ResourceFolder = ({ title, description, link, imgSrc, cta }) => (
  <div className={style.resourceFolder__wrapper}>
    <div>
      {/* className={style.resourceFolder__contentWrapper} */}
      {/* Add back className when images are confirmed - HRGLABS-2421 */}
      <div className={style.resourceFolder__textWrapper}>
        <h4 className={style.resourceFolder__title}>{title}</h4>
        <p className={style.resourceFolder__description}>
          <b>{description}</b>
        </p>
      </div>
      <div className={style.resourceFolder__imgWrapper} hidden={true}>
        {/* Hidden for now till images are confirmed - HRGLABS-2421 */}
        <img src={imgSrc} className={style.resourceFolder__img} hidden={true} />
        {/* Hidden for now till images are confirmed - HRGLABS-2421 */}
      </div>
    </div>

    <span className="d-flex justify-content-end">
      <Link to={link} style={{ textDecoration: "none" }}>
        <button
          className={`btn btn-block btn-primary ${style.resourceFolder__button}`}
        >
          {cta}
        </button>
      </Link>
    </span>
  </div>
);

ResourceFolder.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  link: string,
  cta: string,
  imgSrc: string,
};

export default ResourceFolder;
